module.exports = __webpack_public_path__ + "static/media/404-vector-girl.6d5fd1a9.png";